import {
    Form, FormButton, FormButtonContainer, FormItem, FormItemType, FormSubmitHandler, OptionProps, SelectInput, useAlerts, useForm,
} from "@sis/react-library"
import { CityTownDto, CountryDto, ExampleDto } from "./FormSamplesSettingValuesDynamicallyPage";
import { useState } from "react";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

/////////////////////////////////////////////////////////////////////////////////////////////
// Hardcoded list for cities and countries for example purposes
/////////////////////////////////////////////////////////////////////////////////////////////
const countryList: CountryDto[] = [
    { code: "UK", description: "United Kingdom" },
    { code: "USA", description: "United States" },
    { code: "SA", description: "South Africa" }
]

const cityTownList: CityTownDto[] = [
    { code: "LND", description: "London", countryCode: "UK" },
    { code: "MCH", description: "Manchester", countryCode: "UK" },
    { code: "MK", description: "Milton Keynes", countryCode: "UK" },
    { code: "NOT", description: "Nottingham", countryCode: "UK" },
    { code: "NY", description: "New York", countryCode: "USA" },
    { code: "LA", description: "Los Angeles", countryCode: "USA" },
    { code: "BOS", description: "Boston", countryCode: "USA" },
    { code: "JHB", description: "Johannesburg", countryCode: "SA" },
    { code: "CT", description: "Cape Town", countryCode: "SA" },
    { code: "DRN", description: "Durban", countryCode: "SA" },
    { code: "PTA", description: "Pretoria", countryCode: "SA" }
]

interface FormSamplesSettingValuesDynamicallyFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesSettingValuesDynamicallyForm = ({
    onSubmit, submitting
}: FormSamplesSettingValuesDynamicallyFormProps) => {

    const formName = 'FormSettingValuesDynamically';

    const [filteredCityTownList, setFilteredCityTownList] = useState<CityTownDto[]>([])

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Use the form hooks setItem and getItem to set or get the form values dynamically
    /////////////////////////////////////////////////////////////////////////////////////////////
    const { resetForm, setItem, getItem } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    // The country value has changed, set the city to blank and only show cities for that country
    const handleCountryChange = (countryCode: FormItemType) => {
        const currentCityTownField = getItem('cityTownCode');
        console.log(`The current city/town is '${currentCityTownField.value as string}' and will be reset because country changed.`);
        setItem('cityTownCode', '');
        setFilteredCityTownList(cityTownList.filter((c) => c.countryCode === countryCode));
    }

    const getCountryOptions = (countryList: CountryDto[]): OptionProps[] => {
        return countryList.map(c => ({
            value: c.code,
            description: c.description
        }));
    }

    const getCityTownOptions = (cityTownList: CityTownDto[]): OptionProps[] => {
        return cityTownList.map(c => ({
            value: c.code,
            description: c.description
        }));
    }

    const countryOptions = getCountryOptions(countryList);
    const cityTownOptions = getCityTownOptions(filteredCityTownList);

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="countryCode"
                label="Country"
                /////////////////////////////////////////////////////////////////////////////////////////////
                // Method below fires when value has changed
                /////////////////////////////////////////////////////////////////////////////////////////////
                onItemChange={handleCountryChange}
                element={<SelectInput options={countryOptions} />}
            />
            <FormItem<T>
                formField="cityTownCode"
                label="City/Town"
                element={<SelectInput options={cityTownOptions} />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>
    )
}
